export default __webpack_public_path__ + "static/media/fad-logo-vst.7299b3c4.svg";